import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import { SortOrder } from "interfaces/SortOrder";

export const trainers = (
  trainerName: string
): racehorse360.IListTrainersRequest => ({
  query: {
    fullName: {
      contains: trainerName
    }
  },
  pagingOptions: {
    maxResults: 100 // arbitrary.. should be enough for now
  },
  getOptions: {
    select: [
      "firstName",
      "lastName",
      "type",
      "trainerNumber",
      "horsesOnGround"
    ],
    orderBy: [`fullName ${SortOrder.ASC}`]
  }
});
